<script setup>
import { defineProps, ref} from 'vue'
import ClSlider from '@/components/base/ClSlider.vue'
import ProductCard from '@/components/home/ProductCard.vue'
const breakPoints = ref( {
  xs: {
    itemToShow: 1,
      itemToSlide: 1
  },
  sm: {
    itemToShow: 1,
      itemToSlide: 1
  },
  md: {
    itemToShow:2,
      itemToSlide: 1
  },
  lg: {
    itemToShow: 3,
      itemToSlide: 1
  },
  xl: {
    itemToShow: 4,
      itemToSlide: 1
  }
},)
const props = defineProps({
  items: {
    type: Object,
    required: true,
  }
})
</script>

<template>
  <v-row>
    <v-col cols="12">
      <ClSlider  :items="props.items" infinity :break-points="breakPoints"  :autoplay="false" >
        <template #item="{ item }">
           <ProductCard :item="item"></ProductCard>
        </template>
      </ClSlider>
    </v-col>
  </v-row>
</template>

<style scoped lang="scss">

</style>
